import { combineEpics, ofType } from 'redux-observable'
import { concat, from, of } from 'rxjs'
import { catchError, filter, map, mergeMap } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  deleteCredentialsError,
  deleteCredentialsSuccess,
  disableIntegrationError,
  disableIntegrationSuccess,
  enableIntegrationError,
  enableIntegrationSuccess,
  getStatusError,
  getStatusSuccess,
  setLoader,
} from './actions'
import {
  DELETE_CREDENTIALS_REQUEST_ASYNC,
  DISABLE_INTEGRATION_REQUEST_ASYNC,
  ENABLE_INTEGRATION_REQUEST_ASYNC,
  STATUS_REQUEST_ASYNC,
} from './constants'
import { selectLoader } from './selectors'

const getStatusEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      STATUS_REQUEST_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      ENABLE_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      DISABLE_INTEGRATION_REQUEST_ASYNC.SUCCESS,
      DELETE_CREDENTIALS_REQUEST_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS) {
        return matchURL(URL_CONST.settings.emailServer)
      }

      return true
    }),
    mergeMap(() => {
      const state = state$.value
      const companyId = state.partnerOptions.selectedCompany?.value
      const isLoading = selectLoader(state)

      const actions = []

      if (!isLoading) {
        actions.push(setLoader(true))
      }

      return concat(
        from(actions),
        api.settings.getGsuiteStatus(companyId).pipe(map(getStatusSuccess))
      ).pipe(catchError((error) => of(epicsErrorHandler(getStatusError, error), setLoader(false))))
    })
  )

const enableIntegrationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(ENABLE_INTEGRATION_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings.enableGsuiteIntegration(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => enableIntegrationSuccess(response)),
        catchError((error) =>
          of(
            epicsErrorHandler(enableIntegrationError, error),
            addToast({ message: error.response?.message, type: 'error' })
          )
        )
      )
    )
  )

const disableIntegrationEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DISABLE_INTEGRATION_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .disableGsuiteIntegration(state$.value.partnerOptions.selectedCompany?.value)
        .pipe(
          map((response) => disableIntegrationSuccess(response)),
          catchError((error) =>
            of(
              epicsErrorHandler(disableIntegrationError, error),
              addToast({ message: error.response?.message, type: 'error' })
            )
          )
        )
    )
  )

const deleteCredentialsEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DELETE_CREDENTIALS_REQUEST_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings.deleteGsuiteCredentials(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => deleteCredentialsSuccess(response)),
        catchError((error) =>
          of(
            epicsErrorHandler(deleteCredentialsError, error),
            addToast({ message: error.response?.message, type: 'error' })
          )
        )
      )
    )
  )

export default combineEpics(
  getStatusEpic,
  enableIntegrationEpic,
  disableIntegrationEpic,
  deleteCredentialsEpic
)
